import { toast } from "react-toastify";
import axiosInstance from "../../../../../axiosInstance";
import { HRMS_FINANCE_API_URL } from "../../../../Constants/baseConstant";
import { getDomain, getEmployeeId, getUserId } from "../../../Base/helper/baseFunctions";


// --- Payroll Reporting Employee Helper ---
export const GetPayrollReportingEmployeeHelper = async (params) => {
  return await axiosInstance(`/finance/getPayrollReportingEmployee`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      reporting_manager_id: getEmployeeId(),
      daily_wage: params?.daily_wage,
      user_id: getUserId(),
      ats_work_location_json: null
    }
  })
    .then((res) => ({
      message: "Payroll reporting employees retrieved successfully",
      hasError: false,
      data: res?.data,
    }))
    .catch((err) => ({
      message: "Unable to retrieve payroll reporting employees",
      hasError: true,
      data: err?.response?.data,
    }));
};

export const GetEmployeePostAdjustmentHelper = async (params) => {
  return await axiosInstance(`/finance/getEmployeePostAdjustment`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      emp_user_id: getUserId(),
      month: params?.month,
      year: params?.year,
    }
  })
    .then((res) => ({
      message: "Employee post adjustment retrieved successfully",
      hasError: false,
      data: res?.data,
    }))
    .catch((err) => ({
      message: "Unable to retrieve employee post adjustment",
      hasError: true,
      data: err?.response?.data,
    }));
};

export const AddEmployeePostAdjustmentHelper = async (params) => {
  toast.dismiss();
  toast.info("Saving...");
  return await axiosInstance(`/finance/addEmployeePostAdjustment`, {
    method: "POST",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      user_id: getUserId(),
      employee_fk: params?.employee_fk,
      component_json: params?.component_json,
      month: params?.month,
      year: params?.year,
      flag: params?.flag,
      tab: params?.tab,
      record_date: params?.record_date,
      amount: params?.amount,
      comments: params?.comments || "",
    }
  })
    .then((res) => {
      toast.dismiss();
      toast.success(`Employee ${params?.tab === "adjustment" ? "adjustment" : "work-base pay"} added successfully`);
      return {
        message: "Employee adjustment added successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message);
      return {
        message: "Unable to add employee adjustment",
        hasError: true,
        data: err?.response?.data,
      };
    });
};

export const UpdateEmployeePostAdjustmentHelper = async (params) => {
  toast.dismiss();
  toast.info("Saving...");
  return await axiosInstance(`/finance/updateEmployeePostAdjustment`, {
    method: "PUT",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      user_id: getUserId(),
      employee_fk: params?.employee_fk,
      component_json: params?.component_json,
      month: params?.month,
      year: params?.year,
      flag: params?.flag,
      record_date: params?.record_date,
      amount: params?.amount,
      comments: params?.comments || "",
      employee_post_adjustments_id: params.employee_post_adjustments_id,
    }
  })
  .then((res) => {
    toast.dismiss();
    toast.success(`Employee ${params?.tab === "adjustment" ? "adjustment" : "work-base pay"} updated successfully`);
      return {
        message: "Employee adjustment updated successfully",
        hasError: false,
        data: res?.data,
      };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message);
      return {
        message: "Unable to update employee post adjustment",
        hasError: true,
        data: err?.response?.data,
      };
    });
};

export const DeleteEmployeePostAdjustmentHelper = async (params) => {
  toast.dismiss();
  toast.info("Deleting...");
  return await axiosInstance(`/finance/deleteEmployeePostAdjustment`, {
    method: "DELETE",
    baseURL: HRMS_FINANCE_API_URL,
    data: {
      domain_name: getDomain(),
      user_id: getUserId(),
      employee_post_adjustments_id: params.employee_post_adjustments_id,
      month: params?.month,
      year: params?.year,
    }
  })
  .then((res) => {
      toast.dismiss();
      toast.success(`Employee ${params?.tab === "adjustment" ? "adjustment" : "work-base pay"} deleted successfully`)
      return { message: "Success", hasError: false, data: res?.data }
  }).catch(err => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message)
      return { message: "Error", hasError: true, data: err?.response?.data }
  })
};
